import { getCommissionCyclesTree } from "@/Common/api/commissionCycles/queries";
import { useLocationId } from "@/Common/hooks/Location/useLocationId";
import { useQuery } from "@tanstack/react-query";

export function useCommissionCyclesTree() {
	const locationId = useLocationId();

	const { data, isLoading } = useQuery({
		queryKey: ["commissionCyclesTree", locationId],
		queryFn: () => getCommissionCyclesTree(locationId),
		staleTime: Infinity,
		enabled: Boolean(locationId),
	});

	return { data, isLoading };
}
